import { render, staticRenderFns } from "./InstructionFormBuilder.vue?vue&type=template&id=3897558f&"
import script from "./InstructionFormBuilder.vue?vue&type=script&lang=js&"
export * from "./InstructionFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./InstructionFormBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports